import { api } from '@/lib/api';

export interface WordDefinition {
  definition: string;
  example?: string;
  synonyms?: string[];
  antonyms?: string[];
}

export interface WordMeaning {
  partOfSpeech: string;
  definitions: WordDefinition[];
  synonyms?: string[];
  antonyms?: string[];
}

export interface Phonetic {
  text: string;
  audio?: string;
  sourceUrl?: string;
  license?: {
    name: string;
    url: string;
  };
}

export interface License {
  name: string;
  url: string;
}

export interface SearchedWordData {
  word: string;
  phonetic?: string;
  phonetics?: Phonetic[];
  meanings: WordMeaning[];
  license?: License;
  sourceUrls?: string[];
}

export interface WordSearchData {
  word: string;
  data: SearchedWordData[];
  cached: boolean;
}

export interface WordSearchResponse {
  success?: boolean;
  ok?: boolean;
  data: WordSearchData;
}

export const wordSearchService = {
  /**
   * Search for a word in the dictionary
   * Auto-normalizes input to Title Case
   */
  searchWord: async (query: string): Promise<WordSearchData> => {
    if (!query.trim()) {
      throw new Error('Please enter a word to search');
    }

    const response = await api.get<WordSearchResponse>(`/word/search?q=${encodeURIComponent(query)}`);

    const isSuccess = response.success || response.ok;
    if (!isSuccess || !response.data?.data) {
      throw new Error('Word not found');
    }

    return response.data;
  },
};
